import React from 'react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  limit?: number;
  limitOptions?: number[];
  onLimitChange?: (limit: number) => void;
  total?: number;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  limit,
  limitOptions,
  onLimitChange,
  total,
}) => {
  const showLimitSelector = limit !== undefined && limitOptions && onLimitChange;

  // Calculate display range
  const startItem = total !== undefined && total > 0 ? (currentPage - 1) * (limit || 10) + 1 : 0;
  const endItem = total !== undefined ? Math.min(currentPage * (limit || 10), total) : 0;

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-4 pt-4 border-t">
      {/* Left side - limit selector */}
      {showLimitSelector && (
        <div className="flex items-center gap-2">
          <label htmlFor="limit-select" className="text-sm text-gray-600">
            Показывать:
          </label>
          <select
            id="limit-select"
            value={limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
            className="px-2 py-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {limitOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Center - page navigation */}
      <div className="flex items-center gap-4">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage <= 1}
          className="px-3 py-1 rounded-md bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <span className="text-sm text-gray-600">
          Страница {currentPage} из {totalPages || 1}
        </span>

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage >= totalPages}
          className="px-3 py-1 rounded-md bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      {/* Right side - showing X-Y of Z */}
      {total !== undefined && (
        <div className="text-sm text-gray-500">
          {total > 0 ? `${startItem}-${endItem} из ${total}` : 'Нет записей'}
        </div>
      )}
    </div>
  );
};

export default Pagination;
